import { InlineNotification, Typography } from '@sanlam-glacier/app-common/components';
import styles from './documents-required.module.scss';
import DocumentInstructions from '../../atoms/documentInstructions/DocumentInstructions';
import DocumentsRequiredTable from '../../organisms/documents-required-table/DocumentsRequiredTable';
import { InstructionTabProps } from 'modules/case-tracking/types/documents-required/documents-required.types';

const DocumentsRequired = ({
  isDocumentsRequired,
  documents,
  clientName,
  instructionId,
  isCancelled
}: InstructionTabProps) => {
  const notificationText = () => {
    if (isCancelled && isDocumentsRequired) {
      return 'These were required documents outstanding for this instruction.';
    }

    // TODO: - Need more information/ investigation regarding this from BA
    //       - Might need to add 'previousDocumentsRequested' check
    if (isCancelled) {
      return 'No documents required. Any requested documents will appear here.';
    }

    if (isDocumentsRequired) {
      return 'There are required documents that are missing for this instruction. Please send through the documents listed below as soon as possible.';
    }

    return 'All required documents have been received.';
  };

  return (
    <div className={styles.container}>
      <div className={styles.headingContainer}>
        <Typography variant={Typography.VARIANT.H4} weight={Typography.WEIGHT.MEDIUM}>
          Outstanding documents
        </Typography>
        <Typography variant={Typography.VARIANT.B3}>
          Please provide the following documents for this instruction:
        </Typography>
      </div>
      <div className={styles.notification}>
        <InlineNotification
          headerText={notificationText()}
          status={
            isCancelled
              ? InlineNotification.STATUS.INFO
              : isDocumentsRequired
                ? InlineNotification.STATUS.ALERT
                : InlineNotification.STATUS.SUCCESS
          }
          variant={InlineNotification.VARIANT.SECONDARY}
        />
      </div>
      {isDocumentsRequired && (
        <div className={styles.documentsContainer}>
          <div className={styles.documentsTable}>
            <DocumentsRequiredTable documents={documents} />
          </div>
          {!isCancelled && (
            <DocumentInstructions instructionId={instructionId} clientName={clientName} />
          )}
        </div>
      )}
    </div>
  );
};

export default DocumentsRequired;
